import React from 'react';
import siteData from '@/data/siteData.json';

export const Brands = () => {
  return (
    <section id="marcas" className="py-20 md:py-28 bg-background">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Parceiros
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Marcas que Confiamos
          </h2>
          <p className="text-muted-foreground text-base md:text-lg">
            Trabalhamos com as principais marcas do mercado de automação industrial
          </p>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {siteData.brands.map((brand, index) => (
            <div
              key={brand.id}
              className="brand-logo group cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex flex-col items-center gap-4">
                <div className="h-16 w-full flex items-center justify-center">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-h-12 max-w-[120px] object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div
                    className="hidden items-center justify-center h-12 px-4 rounded bg-muted"
                    style={{ display: 'none' }}
                  >
                    <span className="font-display font-bold text-lg text-foreground">
                      {brand.name}
                    </span>
                  </div>
                </div>
                <span className="text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
                  {brand.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Text */}
        <p className="text-center text-sm text-muted-foreground mt-12">
          E muitas outras marcas. Entre em contato para mais informações.
        </p>
      </div>
    </section>
  );
};
